import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {BehaviorSubject, map, mergeWith, Observable, scan, shareReplay, switchMap, tap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FavoritesServiceService {

  http = inject(HttpClient);
  addAction$$ = new BehaviorSubject<any>(null);
  updateAction$$ = new BehaviorSubject<any>(null);
  changePositionAction$$ = new BehaviorSubject<any>(null);
  deleteAction$$ = new BehaviorSubject<any | null>(null);  // Assuming the id of the favorite is being passed for deletion
  isLoadingAction$$ = new BehaviorSubject<string | null>(null);
  addLike$$ = new BehaviorSubject<any>(null);
  deleteLike$$ = new BehaviorSubject<any>(null);
  favoriteAdded$ = this.addAction$$.pipe(
    tap((favorite)=>this.isLoading(favorite?.url)),
    switchMap((favorite) => favorite ? this.setFavorite(favorite).pipe(
      map(result => ({ favorite, result, actionType: 'add' }))
    ) : []),
  );

  favoriteUpdated$ = this.updateAction$$.pipe(
    tap((favorite)=>this.isLoading(favorite?.url)),
    switchMap((favorite) => favorite ? this.updateFavorite(favorite).pipe(
      map(result => ({ favorite, result, actionType: 'update' }))
    ) : []),
  );

  favoriteChangePosition$ = this.changePositionAction$$.pipe(
    tap((favorite)=>this.isLoading(favorite?.url)),
    switchMap((favorite) => favorite ? this.updateFavorite(favorite.target).pipe(
      map(result => ({ favorite, result, actionType: 'changePosition' }))
    ) : []),
  );

  favoriteDeleted$ = this.deleteAction$$.pipe(
    tap((favorite)=>this.isLoading(favorite?.url)),
    switchMap((favorite) => favorite ? this.deleteFavorite(favorite.id).pipe(
      map(result => ({ favorite, result, actionType: 'delete' }))
    ) : []),
  );

  favoriteList$ = this.getFavorites().pipe(
    mergeWith(
      this.favoriteAdded$,
      this.favoriteUpdated$,
      this.favoriteChangePosition$,
      this.favoriteDeleted$
    ),
    scan((favorites, action) => {
      switch (action.actionType ) {
        case 'add':
          return [...favorites, action.result];
        case 'update':
          return favorites.map((favorite: any) => favorite.id === action.favorite.id ? {...favorite, ...action.favorite} : favorite);
        case 'changePosition':
          return favorites.map((favorite: any) => {
            if(favorite.id === action.favorite.source.id){
              return {...favorite, ...action.favorite.source}
            }else if(favorite.id === action.favorite.target.id){
              return {...favorite, ...action.favorite.target}
            }else{
              return favorite
            }
          });
        case 'delete':
          return favorites.filter((favorite:any) => favorite.id !== action.favorite.id);
        default:
          return favorites;
      }
    }),
    tap(()=>this.isLoading(null)),
    shareReplay(1)
  );

  isLoading(url:string | null){
    this.isLoadingAction$$.next(url);
  }
  getFavorites() {
    return this.http.get<any>('/api/favorite/v1/get/favorites').pipe(
      map(response => response.data),
    );
  }
  setFavorite(favorite:any) {
    return this.http.post<any>('/api/favorite/v1/set', favorite).pipe(
      map(response => response.data)
    )
  }
  updateFavorite(favorite:any) {
    return this.http.post<any>('/api/favorite/v1/set/update', favorite).pipe(
      map(response => response.data)
    )
  }
  deleteFavorite(id:string | number) {
    return this.http.delete<any>(`/api/favorite/v1/set/delete/${id}`);
  }

  likeSet(payload : any) : Observable<any>{
    return this.http.post<any>("/api/catalogue/v1/set/resource/rating", payload).pipe(
      map((data)=>data))
  }
  getLike(): Observable<any>{
    return this.http.get<any>("")
  }

}
